export const isWithinStandardDeviation = (
  value1: number,
  value2: number,
  deviation: number = 0.05
) => {
  const difference = Math.abs(value1 - value2);
  const average = (value1 + value2) / 2;
  return difference / average <= deviation;
};
